import { Button, type ButtonProps } from '../Elements/Button';
import { useCRUDDelete } from './CRUDForm';

export function CRUDDeleteButton(props: Omit<ButtonProps, 'onClickCapture'>) {
  const onSubmitCapture = useCRUDDelete();
  return <Button disabled={!onSubmitCapture} onClickCapture={onSubmitCapture} {...props} />;
}
